export type IPDetails = {
  userId: string;
  guid: string;
  address: string;
  type: string;
  description: string;
  captcha: boolean;
};
export enum IPType {
  'IPV4' = 'IPv4',
  'IPV6' = 'IPv6',
}
